var map = {
	"./advisory/singapore-border-corona.png": 4570,
	"./awsaccelerator2021/animate-fireworks": 94172,
	"./awsaccelerator2021/animate-fireworks.json": 94172,
	"./awsaccelerator2021/aws-deepracer-img-1.jpg": 8917,
	"./awsaccelerator2021/aws-deepracer-img-2.jpg": 84778,
	"./awsaccelerator2021/aws-deepracer-img-3.jpg": 80583,
	"./awsaccelerator2021/aws-deepracer-img-4.jpg": 26172,
	"./awsaccelerator2021/aws-logo-black.png": 48725,
	"./awsaccelerator2021/aws-logo-white.png": 1311,
	"./awsaccelerator2021/aws-logo.png": 52911,
	"./awsaccelerator2021/aws-logo.svg": 65878,
	"./awsaccelerator2021/blue-school.svg": 63104,
	"./awsaccelerator2021/car-animated": 92368,
	"./awsaccelerator2021/car-animated.json": 92368,
	"./awsaccelerator2021/cloud-computing-logo.png": 98080,
	"./awsaccelerator2021/deepracer-logo.png": 14741,
	"./awsaccelerator2021/dunman-logo.png": 75173,
	"./awsaccelerator2021/imda-logo.png": 63537,
	"./awsaccelerator2021/orange-school.svg": 12078,
	"./awsaccelerator2021/orange-tent.svg": 42897,
	"./awsaccelerator2021/tampines-town-council-logo.png": 74632,
	"./awsaccelerator2022/arrow-right.svg": 50888,
	"./awsaccelerator2022/aws-certified-cloud-practitioner-logo.png": 60055,
	"./awsaccelerator2022/aws-deepracer-banner.jpg": 50011,
	"./awsaccelerator2022/aws-partner-logo.svg": 22624,
	"./awsaccelerator2022/aws-sgcc-orange-logo.svg": 56307,
	"./awsaccelerator2022/calendar.svg": 27184,
	"./awsaccelerator2022/clear.svg": 77357,
	"./awsaccelerator2022/deepracer-logo.png": 65684,
	"./awsaccelerator2022/dunman-logo.png": 67370,
	"./awsaccelerator2022/laptop.svg": 4554,
	"./awsaccelerator2022/play.svg": 78944,
	"./awsaccelerator2022/python.svg": 19096,
	"./awsaccelerator2022/testimonial-ashley.png": 98571,
	"./awsaccelerator2022/testimonial-isabella.png": 73918,
	"./awsaccelerator2022/testimonial-ved.png": 98920,
	"./awsaccelerator2024/arrow-right.svg": 36582,
	"./awsaccelerator2024/aws-certified-cloud-practitioner-logo.png": 59217,
	"./awsaccelerator2024/aws-deepracer-banner.jpg": 83457,
	"./awsaccelerator2024/aws-partner-logo.svg": 43178,
	"./awsaccelerator2024/aws-sgcc-orange-logo.svg": 19033,
	"./awsaccelerator2024/calendar.svg": 64630,
	"./awsaccelerator2024/clear.svg": 65075,
	"./awsaccelerator2024/deepracer-logo.png": 56374,
	"./awsaccelerator2024/dunman-logo.png": 90588,
	"./awsaccelerator2024/farrer-park-hospital.png": 68375,
	"./awsaccelerator2024/laptop.svg": 8160,
	"./awsaccelerator2024/nparks.png": 59340,
	"./awsaccelerator2024/play.svg": 56650,
	"./awsaccelerator2024/python.svg": 41138,
	"./awsaccelerator2024/seoul-garden.png": 40011,
	"./awsaccelerator2024/testimonial-ashley.png": 37517,
	"./awsaccelerator2024/testimonial-isabella.png": 79132,
	"./awsaccelerator2024/testimonial-ved.png": 48086,
	"./blog/left-image.svg": 85671,
	"./blog/mobile-image.svg": 60898,
	"./blog/right-image.svg": 39634,
	"./codie/Asset-1.svg": 11768,
	"./codie/Asset-10.svg": 20248,
	"./codie/Asset-11.svg": 79401,
	"./codie/Asset-12.svg": 53818,
	"./codie/Asset-13.svg": 59083,
	"./codie/Asset-14.svg": 94372,
	"./codie/Asset-15.svg": 72389,
	"./codie/Asset-16.svg": 52518,
	"./codie/Asset-17.svg": 98967,
	"./codie/Asset-18.svg": 93760,
	"./codie/Asset-19.svg": 50673,
	"./codie/Asset-2.svg": 50603,
	"./codie/Asset-20.svg": 23825,
	"./codie/Asset-21.svg": 9440,
	"./codie/Asset-22.svg": 54099,
	"./codie/Asset-23.svg": 66722,
	"./codie/Asset-24.svg": 95245,
	"./codie/Asset-25.svg": 47884,
	"./codie/Asset-26.svg": 26911,
	"./codie/Asset-27.svg": 95918,
	"./codie/Asset-28.svg": 25705,
	"./codie/Asset-29.svg": 344,
	"./codie/Asset-3.svg": 31546,
	"./codie/Asset-30.svg": 94630,
	"./codie/Asset-31.svg": 82167,
	"./codie/Asset-32.svg": 39044,
	"./codie/Asset-33.svg": 93765,
	"./codie/Asset-34.svg": 82138,
	"./codie/Asset-35.svg": 1195,
	"./codie/Asset-36.svg": 62360,
	"./codie/Asset-37.svg": 97225,
	"./codie/Asset-38.svg": 44142,
	"./codie/Asset-39.svg": 48895,
	"./codie/Asset-4.svg": 43173,
	"./codie/Asset-40.svg": 69023,
	"./codie/Asset-5.svg": 88452,
	"./codie/Asset-6.svg": 31575,
	"./codie/Asset-7.svg": 44038,
	"./codie/Asset-8.svg": 18897,
	"./codie/Asset-9.svg": 56096,
	"./courserecommender/no-campus.svg": 43145,
	"./courses/academics-campus.svg": 59942,
	"./courses/academics-campus2.svg": 93832,
	"./courses/academics/cluster1.svg": 25260,
	"./courses/academics/cluster2.svg": 80607,
	"./courses/academics/cluster3.svg": 75854,
	"./courses/academics/ib-tuition-external-assessment/comment.jpg": 72513,
	"./courses/academics/ib-tuition-external-assessment/content.jpg": 95405,
	"./courses/academics/ib-tuition-internal-assessment/comment.jpg": 97059,
	"./courses/academics/ib-tuition-internal-assessment/content.jpg": 92499,
	"./courses/academics/ib-tuition-java-holiday-camp-1/comment.jpg": 496,
	"./courses/academics/ib-tuition-java-holiday-camp-1/content.jpg": 20256,
	"./courses/academics/ib-tuition-java-holiday-camp-2/comment.jpg": 26843,
	"./courses/academics/ib-tuition-java-holiday-camp-2/content.jpg": 99291,
	"./courses/academics/ib-tuition-java-programming/comment.jpg": 20113,
	"./courses/academics/ib-tuition-java-programming/content.jpg": 47709,
	"./courses/academics/java2/comment.jpg": 68328,
	"./courses/academics/java2/content.jpg": 45096,
	"./courses/basics-campus.svg": 82717,
	"./courses/basics/basics1/comment.jpg": 39761,
	"./courses/basics/basics1/content.jpg": 83709,
	"./courses/basics/basics1/pie.svg": 76833,
	"./courses/basics/basics1/second-image.gif": 34035,
	"./courses/basics/basics2/comment.jpg": 15514,
	"./courses/basics/basics2/content.jpg": 76334,
	"./courses/basics/basics2/pie.svg": 51174,
	"./courses/basics/basics2/second-image.gif": 64694,
	"./courses/basics/basics3/comment.jpg": 20695,
	"./courses/basics/basics3/content.jpg": 70903,
	"./courses/basics/basics3/pie.svg": 96787,
	"./courses/basics/basics3/second-image.gif": 25989,
	"./courses/basics/basics4/comment.jpg": 22784,
	"./courses/basics/basics4/content.jpg": 16080,
	"./courses/basics/basics4/pie.svg": 22136,
	"./courses/basics/basics4/second-image.gif": 86160,
	"./courses/basics/basicsx/content.jpg": 89284,
	"./courses/basics/basicsx/pie.svg": 72556,
	"./courses/basics/jrpython1/comment.jpg": 94556,
	"./courses/basics/jrpython1/content.jpg": 45932,
	"./courses/basics/jrpython1/pie.svg": 56604,
	"./courses/basics/jrpython2/comment.jpg": 20055,
	"./courses/basics/jrpython2/content.jpg": 70263,
	"./courses/basics/jrpython2/pie.svg": 85211,
	"./courses/basics/jrpython3/comment.jpg": 14874,
	"./courses/basics/jrpython3/content.jpg": 92046,
	"./courses/basics/jrpython3/pie.svg": 58094,
	"./courses/course-image-1.jpg": 95228,
	"./courses/olevel/olevel-1.jpg": 52918,
	"./courses/path-split.svg": 1754,
	"./courses/principles-campus.svg": 23963,
	"./courses/principles/aws-certified-cloud-practitioner.png": 66423,
	"./courses/principles/aws-certified-solutions-architect-associate.png": 70572,
	"./courses/principles/aws-technical-essentials/aws-certified.png": 52340,
	"./courses/principles/aws-technical-essentials/aws-partner-logo.png": 51909,
	"./courses/principles/aws-technical-essentials/cloud-1.jpeg": 38799,
	"./courses/principles/aws-technical-essentials/cloud-2.png": 64189,
	"./courses/principles/aws-technical-essentials/content.jpg": 21928,
	"./courses/principles/principles1/comment.jpg": 91685,
	"./courses/principles/principles1/content.jpg": 42801,
	"./courses/principles/principles1/pie.svg": 85565,
	"./courses/principles/principles2/comment.jpg": 85086,
	"./courses/principles/principles2/content.jpg": 19938,
	"./courses/principles/principles2/pie.svg": 59826,
	"./courses/principles/principles3/comment.jpg": 52939,
	"./courses/principles/principles3/content.jpg": 71755,
	"./courses/principles/principles3/pie.svg": 14831,
	"./courses/principles/principles4/comment.jpg": 18204,
	"./courses/principles/principles4/content.jpg": 59212,
	"./courses/principles/principles4/pie.svg": 64284,
	"./courses/principles/principles5/comment.jpg": 89169,
	"./courses/principles/principles5/content.jpg": 19965,
	"./courses/principles/principles5/pie.svg": 84278,
	"./courses/principles/principles6/comment.jpg": 87418,
	"./courses/principles/principles6/content.jpg": 58670,
	"./courses/principles/principles6/pie.svg": 15054,
	"./courses/principles/principles7/content.jpg": 9687,
	"./courses/principles/principles7/pie.svg": 69499,
	"./courses/principles/principles8/aws_partner_network_training.png": 37439,
	"./courses/principles/principles8/card-logo-white-bg.svg": 31400,
	"./courses/principles/principles8/card-logo.svg": 66624,
	"./courses/principles/principles8/cloud-1.jpeg": 16047,
	"./courses/principles/principles8/cloud-2.png": 36861,
	"./courses/principles/principles8/content.jpg": 88680,
	"./courses/principles/principlesx/aws_partner_network_training.png": 32735,
	"./courses/principles/principlesx/cloud-1.jpeg": 88143,
	"./courses/principles/principlesx/cloud-2.png": 43453,
	"./courses/principles/principlesx/content.jpg": 29256,
	"./courses/principlesplus/principlesplus1/comment.jpg": 96873,
	"./courses/principlesplus/principlesplus1/content.jpg": 42565,
	"./courses/principlesplus/principlesplus1/pie.svg": 60681,
	"./courses/principlesplus/principlesplus2/comment.jpg": 95538,
	"./courses/principlesplus/principlesplus2/content.jpg": 40854,
	"./courses/principlesplus/principlesplus2/pie.svg": 70990,
	"./holidaycamps/banner1.svg": 51585,
	"./holidaycamps/banner2.svg": 86194,
	"./holidaycamps/banner3.svg": 19235,
	"./holidaycamps/comment.jpg": 42448,
	"./holidaycamps/mobile.svg": 91340,
	"./holidaycamps/sh-campus.svg": 47671,
	"./joinus/banner.png": 70567,
	"./joinus/instructorjob.jpg": 82595,
	"./joinus/mobilebanner.png": 66321,
	"./landing/958.png": 24572,
	"./landing/CNA938.png": 68748,
	"./landing/FM893.svg": 58942,
	"./landing/IBM.png": 35432,
	"./landing/a_star.png": 23448,
	"./landing/aws_academy_member_institution.png": 36410,
	"./landing/banner-left.svg": 66743,
	"./landing/banner-mobile.svg": 33890,
	"./landing/banner-right.svg": 93714,
	"./landing/banner/SGCC_Classroom1.jpg": 54218,
	"./landing/banner/smu_class1.jpg": 72742,
	"./landing/barclays.png": 26579,
	"./landing/berkeley.svg": 74714,
	"./landing/bytedance.svg": 92196,
	"./landing/campus.svg": 83806,
	"./landing/channel-8.jpg": 29312,
	"./landing/dsta.svg": 80655,
	"./landing/grab.png": 21538,
	"./landing/instructors.png": 19662,
	"./landing/mckinsey.svg": 57806,
	"./landing/mit.png": 23712,
	"./landing/partners/apple_consultants_network.png": 27292,
	"./landing/partners/apple_consultants_network.svg": 8481,
	"./landing/partners/aws-partner-logo.png": 21600,
	"./landing/partners/aws-training-advanced-partner.svg": 56161,
	"./landing/partners/aws_partner_network.svg": 93178,
	"./landing/partners/aws_services_partner.png": 67279,
	"./landing/partners/blackrock.png": 39614,
	"./landing/partners/changi_airport_group.png": 89954,
	"./landing/partners/cpf.png": 24617,
	"./landing/partners/dsta.png": 53588,
	"./landing/partners/get-go-logo.png": 60501,
	"./landing/partners/google-cloud-partner.png": 77774,
	"./landing/partners/google-cloud.png": 11775,
	"./landing/partners/google-cloud.svg": 62518,
	"./landing/partners/imda.png": 13065,
	"./landing/partners/imda.svg": 18284,
	"./landing/partners/infineon.png": 40556,
	"./landing/partners/lli.jpeg": 99978,
	"./landing/partners/nus-law.png": 66741,
	"./landing/partners/nus.png": 16722,
	"./landing/partners/nusrisk.png": 21791,
	"./landing/partners/ocbc.png": 66073,
	"./landing/partners/paypal.png": 95403,
	"./landing/partners/shopee.png": 95276,
	"./landing/partners/smu.png": 49101,
	"./landing/partners/smu.svg": 33392,
	"./landing/paypal.svg": 39088,
	"./landing/rsaf.png": 90488,
	"./landing/sea_ltd.svg": 59823,
	"./landing/sgx.png": 65168,
	"./landing/standard-chartered.svg": 59583,
	"./landing/stanford.png": 62283,
	"./landing/the-new-paper.svg": 68850,
	"./landing/the-straits-times.png": 75661,
	"./landing/toggle.svg": 83009,
	"./landing/why-us-backup/1.jpg": 44188,
	"./landing/why-us-backup/2.jpg": 12491,
	"./landing/why-us-backup/3.jpg": 34446,
	"./landing/why-us/1.jpg": 46515,
	"./landing/why-us/2.jpg": 46468,
	"./landing/why-us/3.jpg": 24513,
	"./landing/why-us/4.jpg": 12818,
	"./landing/yahoo-news.png": 72880,
	"./learnmore/contactus/contact-us-banner.svg": 19002,
	"./learnmore/events/past-events-banner.svg": 67772,
	"./learnmore/events/past/bt_open_house_1.jpg": 14705,
	"./learnmore/events/past/bt_open_house_2.jpg": 86950,
	"./learnmore/events/past/community_event_1.jpg": 13095,
	"./learnmore/events/past/community_event_2.jpg": 59288,
	"./learnmore/events/past/honestbee_1.jpg": 54594,
	"./learnmore/events/past/honestbee_2.jpg": 23821,
	"./learnmore/events/past/ipoh_retreat.jpg": 80487,
	"./learnmore/events/past/judges_for_issf.jpg": 52461,
	"./learnmore/events/past/judging_issf2.jpg": 84271,
	"./learnmore/events/past/mp_open_house_2018_1.jpg": 54686,
	"./learnmore/events/past/mp_open_house_2018_2.jpg": 50633,
	"./learnmore/events/past/open_house_may_2019_1.jpg": 71583,
	"./learnmore/events/past/open_house_may_2019_2.jpg": 57232,
	"./learnmore/events/past/shopback_1.jpg": 60800,
	"./learnmore/events/past/shopback_2.jpg": 43791,
	"./learnmore/events/past/sme.jpg": 3776,
	"./learnmore/events/past/sme_2.jpg": 54543,
	"./learnmore/events/past/team_retreat_1.jpg": 15422,
	"./learnmore/events/past/team_retreat_2.jpg": 6921,
	"./learnmore/events/past/today_at_apple_1.jpg": 21345,
	"./learnmore/events/past/today_at_apple_2.jpg": 45558,
	"./learnmore/faq/faq-banner.svg": 49737,
	"./learnmore/policies/banner.svg": 8476,
	"./learnmore/promotions/banner.svg": 27444,
	"./learnmore/promotions/earlybird.png": 34571,
	"./learnmore/promotions/referralprogram.png": 70058,
	"./learnmore/promotions/siblingdiscount.png": 76248,
	"./learnmore/promotions/weekdayweekly.png": 56068,
	"./notfound/codie.svg": 68277,
	"./onlineclasses/keyfeatures/active-student-participation.png": 49569,
	"./onlineclasses/keyfeatures/realtime-consultation.png": 35262,
	"./onlineclasses/keyfeatures/seamless-experience.png": 92948,
	"./onlineclasses/main.png": 14561,
	"./partners/apple/apple-main-banner.jpg": 92664,
	"./partners/apple/apple_consultants_network.png": 46325,
	"./partners/apple/sgcc-apple-consultants-network.png": 34086,
	"./partners/aws/AWS_Classroom1.jpg": 78292,
	"./partners/aws/BuildOn.jpg": 45593,
	"./partners/aws/aws-partner-logo.png": 27342,
	"./partners/aws/aws.png": 67273,
	"./partners/buildon/AWS_Buildon_2019.jpg": 8428,
	"./partners/buildon/AWS_Buildon_2019_2.jpg": 39139,
	"./partners/buildon/build_on_header.png": 69226,
	"./partners/buildon/build_on_instructors.png": 96461,
	"./partners/google/google-cloud-partner.png": 2044,
	"./partners/google/google-cloud.png": 26505,
	"./partners/smu/smu.png": 92761,
	"./partners/smu/smu_1.jpg": 92497,
	"./professional-training/app-development-with-swift.png": 45679,
	"./professional-training/aws-training-and-certification.png": 28892,
	"./professional-training/banner1.jpg": 16288,
	"./professional-training/banner2.jpg": 29903,
	"./professional-training/banner3.jpg": 61970,
	"./professional-training/google-cloud.png": 64410,
	"./professional-training/professional-training-banner-2.png": 94625,
	"./professional-training/professional-training-banner-image.png": 91892,
	"./professional-training/professional-training-journey-begins.png": 42173,
	"./professional-training/professional-training-upskill.png": 90910,
	"./professional-training/professional-training-why-us.png": 3625,
	"./professional-training/sample-1.png": 3119,
	"./professional-training/smuacademy.png": 78618,
	"./professional-training/stock-2.jpg": 47548,
	"./professional-training/stock-image-1.png": 72147,
	"./professional-training/trainers/germaine.jpg": 6804,
	"./professional-training/trainers/huangbin.jpg": 99748,
	"./professional-training/trainers/huiliang.png": 51031,
	"./professional-training/trainers/ian.jpg": 13176,
	"./professional-training/trainers/natasha.png": 38556,
	"./professional-training/trainers/philipbeh.jpg": 4217,
	"./professional-training/trainers/sunchang.jpg": 25583,
	"./professional-training/trainers/terence.jpg": 39916,
	"./professional-training/trainers/yongyang.jpg": 79644,
	"./schedule/banner.svg": 43851,
	"./sgcc-logo.png": 83190,
	"./tertiary/app-dev-with-swift-logo.png": 16925,
	"./tertiary/apple/natasha-trainer.png": 39702,
	"./tertiary/apple/sgcc-apple-consultants-network-logo-white.svg": 49886,
	"./tertiary/apple/sgcodecampus-skillsfuture-apple.jpg": 21773,
	"./tertiary/apple/trainer-eric.svg": 88876,
	"./tertiary/apple/trainer-huiliang.svg": 65708,
	"./tertiary/apple/trainer-yongyang.svg": 44259,
	"./tertiary/aws-authorized-instructor.svg": 35759,
	"./tertiary/aws-certified-cloud-practitioner-logo.png": 34443,
	"./tertiary/aws-cloud-practitioner-logo.png": 81923,
	"./tertiary/aws-partner-logo.svg": 26356,
	"./tertiary/aws-partner-sgcc-logo.svg": 70487,
	"./tertiary/aws-solutions-architect-associate.svg": 93017,
	"./tertiary/aws-sysops-administrator-associate.svg": 16578,
	"./tertiary/aws/aws-graph.png": 64477,
	"./tertiary/aws/checkmark.svg": 59591,
	"./tertiary/aws/icon-background.png": 50553,
	"./tertiary/aws/qr-code.png": 40240,
	"./tertiary/aws/speaker-fang-ting.svg": 94547,
	"./tertiary/aws/speaker-huang-bin.svg": 56223,
	"./tertiary/aws/speaker-ian.svg": 5072,
	"./tertiary/aws/speaker-sun-chang.svg": 58850,
	"./tertiary/aws/tertiary-image-banner.png": 53664,
	"./tertiary/aws/trainer-eric.svg": 40085,
	"./tertiary/aws/trainer-huiliang.svg": 58985,
	"./tertiary/aws/trainer-yongyang.svg": 97074,
	"./tertiary/aws/typing.jpg": 48192,
	"./tertiary/aws/who-should-attend.png": 39148,
	"./tertiary/index/apple-consultants-network-white.png": 18010,
	"./tertiary/index/apple_consultants_network.svg": 38611,
	"./tertiary/index/calendar.svg": 2067,
	"./tertiary/index/forum.svg": 12788,
	"./tertiary/index/homework.svg": 41247,
	"./tertiary/index/tertiary-1.jpg": 32284,
	"./tertiary/index/tertiary-2.jpg": 16939,
	"./tertiary/index/tertiary-3.jpg": 38894,
	"./tertiary/index/verified.svg": 5381,
	"./tertiary/sgcc-logo.svg": 35078,
	"./tertiary/sgcc-white-logo.svg": 84626,
	"./whyus/partners/blackrock.png": 5431,
	"./whyus/partners/ocbc.png": 30250,
	"./whyus/partners/paypal.png": 96024,
	"./whyus/partners/shopee.png": 7047,
	"./whyus/partners/shopee_event.jpg": 57558,
	"./whyus/partners/smu.png": 90948,
	"./whyus/partners/smu_2.jpg": 19727,
	"./whyus/philosophy/better_future_through_code.jpg": 92071,
	"./whyus/philosophy/solving_problems_through_code.jpg": 2282,
	"./whyus/students/achievements.svg": 98467,
	"./whyus/students/achievements/appjamming20191.jpg": 73318,
	"./whyus/students/achievements/appjamming20192.jpg": 14737,
	"./whyus/students/achievements/asiapacific2019silver.jpg": 48159,
	"./whyus/students/achievements/asiapacific2020bronze.jpg": 34212,
	"./whyus/students/achievements/brainhack-2021-4th-place.png": 5079,
	"./whyus/students/achievements/build-on-2021-champion.jpg": 27629,
	"./whyus/students/achievements/buildon_sg_2019.jpg": 87116,
	"./whyus/students/achievements/buildon_sg_2019_2.jpg": 39971,
	"./whyus/students/achievements/cedric-glenda-justin-matthew-marcus.png": 74118,
	"./whyus/students/achievements/daniel-ioi.jpg": 7084,
	"./whyus/students/achievements/dsta2018.jpg": 95324,
	"./whyus/students/achievements/dsta20182.jpg": 26620,
	"./whyus/students/achievements/ibcomputersciencevarun.jpeg": 75338,
	"./whyus/students/achievements/ibmax.jpg": 76514,
	"./whyus/students/achievements/ibmax2.jpg": 12226,
	"./whyus/students/achievements/imda20173rdprize.jpg": 42865,
	"./whyus/students/achievements/imda2017top6.jpg": 17307,
	"./whyus/students/achievements/imda20181stprize.jpg": 6273,
	"./whyus/students/achievements/imda20181stprize2.jpg": 30319,
	"./whyus/students/achievements/imda20182ndprize.jpg": 965,
	"./whyus/students/achievements/imda20182ndprize2.jpg": 53659,
	"./whyus/students/achievements/imda20183rdprize.jpg": 34254,
	"./whyus/students/achievements/imda20183rdprize2.jpg": 90918,
	"./whyus/students/achievements/imda20183rdprizeschool.jpg": 5586,
	"./whyus/students/achievements/imda20183rdprizeschool2.jpg": 81490,
	"./whyus/students/achievements/imda2018top9.jpg": 93779,
	"./whyus/students/achievements/imda2018top92.jpg": 78329,
	"./whyus/students/achievements/imda20191stprize.jpg": 83936,
	"./whyus/students/achievements/imda20191stprize2.jpg": 54696,
	"./whyus/students/achievements/imda20192ndprize.jpg": 63068,
	"./whyus/students/achievements/imda20192ndprize2.jpg": 39452,
	"./whyus/students/achievements/imda2019meritaward.jpg": 29878,
	"./whyus/students/achievements/imda2019meritaward2.jpg": 75294,
	"./whyus/students/achievements/internationalolympiad2019teamsingapore.jpg": 68823,
	"./whyus/students/achievements/lifehack-2021-champion.jpg": 44590,
	"./whyus/students/achievements/matthew.jpg": 30705,
	"./whyus/students/achievements/noi-2021-silver-medal.png": 22857,
	"./whyus/students/achievements/noi2017bronze.jpg": 45971,
	"./whyus/students/achievements/noi2019daniel1.jpg": 84535,
	"./whyus/students/achievements/noi2019daniel2.jpg": 45864,
	"./whyus/students/achievements/noi2020bronze.png": 41829,
	"./whyus/students/achievements/noi2020bronzeivan.png": 93689,
	"./whyus/students/achievements/noi2020honourableyushen.jpg": 85992,
	"./whyus/students/achievements/noi2020silver.jpg": 87406,
	"./whyus/students/achievements/noihonourablemention2019.jpg": 96858,
	"./whyus/students/achievements/seth-nicole-alyssa-jovern.png": 45819,
	"./whyus/students/achievements/shopeedatascience2019.jpeg": 58232,
	"./whyus/students/achievements/vir-markus-edward-erica-julienne.png": 85642,
	"./whyus/students/achievements/yawen.jpg": 28163,
	"./whyus/students/achievements/yawencode.png": 20452,
	"./whyus/students/achievements/youth-founders-summit-2020-2nd-place.png": 98609,
	"./whyus/students/achievements/youthcybersecurity2020.jpg": 71457,
	"./whyus/students/banner1.svg": 18366,
	"./whyus/students/banner2.svg": 30461,
	"./whyus/students/banner3.svg": 1916,
	"./whyus/students/banner4.svg": 29571,
	"./whyus/students/hear-students.svg": 17232,
	"./whyus/students/journey.svg": 16889,
	"./whyus/students/mobile.svg": 20541,
	"./whyus/team/aggielee1.jpg": 63609,
	"./whyus/team/aggielee2.jpg": 56494,
	"./whyus/team/ailin1.png": 26555,
	"./whyus/team/ailin2.png": 48224,
	"./whyus/team/angie1.jpg": 66460,
	"./whyus/team/angie2.jpg": 51115,
	"./whyus/team/banner1.svg": 76041,
	"./whyus/team/banner2.svg": 7930,
	"./whyus/team/celestial1.png": 97604,
	"./whyus/team/celestial2.png": 52255,
	"./whyus/team/clarence.jpg": 51386,
	"./whyus/team/clarence2.jpg": 66698,
	"./whyus/team/cw.jpg": 45517,
	"./whyus/team/cw2.jpg": 41747,
	"./whyus/team/david.jpg": 61217,
	"./whyus/team/david2.jpg": 63183,
	"./whyus/team/derrick.jpeg": 44016,
	"./whyus/team/derrick.jpg": 19975,
	"./whyus/team/derrick1.jpg": 84394,
	"./whyus/team/derrick2.jpeg": 93258,
	"./whyus/team/derrick2.jpg": 8533,
	"./whyus/team/douglas1.png": 20849,
	"./whyus/team/douglas2.png": 99738,
	"./whyus/team/eric.jpg": 42238,
	"./whyus/team/eric1.jpg": 76065,
	"./whyus/team/eric2.jpg": 83926,
	"./whyus/team/fangting1.jpg": 16332,
	"./whyus/team/fangting2.jpg": 76955,
	"./whyus/team/flo.jpg": 33186,
	"./whyus/team/flo2.png": 57286,
	"./whyus/team/gab.jpg": 59077,
	"./whyus/team/gab2.png": 81123,
	"./whyus/team/gabrielcheang1.jpg": 66490,
	"./whyus/team/gabrielcheang2.jpg": 23717,
	"./whyus/team/gabrielwong.png": 45094,
	"./whyus/team/gabrielwong1.jpg": 50029,
	"./whyus/team/gabrielwong2.jpg": 17890,
	"./whyus/team/gabrielwong2.png": 91974,
	"./whyus/team/gary1.jpg": 25139,
	"./whyus/team/gary2.jpg": 25092,
	"./whyus/team/germ.jpg": 25948,
	"./whyus/team/germ2.jpg": 31164,
	"./whyus/team/germaine1.jpg": 20264,
	"./whyus/team/germaine2.jpg": 5015,
	"./whyus/team/grace1.jpg": 34342,
	"./whyus/team/grace2.jpg": 66545,
	"./whyus/team/hari1.jpg": 70888,
	"./whyus/team/hari2.jpg": 39287,
	"./whyus/team/huangbin.jpg": 98925,
	"./whyus/team/huangbin1.jpg": 58340,
	"./whyus/team/huangbin2.jpg": 36147,
	"./whyus/team/huiliang.jpg": 68586,
	"./whyus/team/huiliang1.jpg": 39973,
	"./whyus/team/huiliang2.jpg": 35770,
	"./whyus/team/ian.jpg": 4251,
	"./whyus/team/ian2.jpg": 75089,
	"./whyus/team/jerrel.png": 21019,
	"./whyus/team/jerrel1.jpg": 4110,
	"./whyus/team/jerrel2.png": 84513,
	"./whyus/team/jireh.jpg": 35395,
	"./whyus/team/jireh1.jpg": 94206,
	"./whyus/team/jireh2.jpg": 37289,
	"./whyus/team/joanna.jpg": 15764,
	"./whyus/team/joanna2.jpg": 38660,
	"./whyus/team/jonny.jpg": 23273,
	"./whyus/team/jonny1.jpg": 25816,
	"./whyus/team/jonny2.jpg": 88391,
	"./whyus/team/joshua1.png": 64496,
	"./whyus/team/joshua2.png": 35787,
	"./whyus/team/justin1.png": 3707,
	"./whyus/team/justin2.png": 25376,
	"./whyus/team/keith1.jpg": 14465,
	"./whyus/team/keith2.jpg": 24886,
	"./whyus/team/linda.jpg": 90231,
	"./whyus/team/linda1.jpg": 53530,
	"./whyus/team/linda2.jpg": 76133,
	"./whyus/team/manling.jpg": 9371,
	"./whyus/team/manling2.jpg": 90801,
	"./whyus/team/munmun.jpg": 13307,
	"./whyus/team/munmun2.jpg": 78097,
	"./whyus/team/nandini1.jpg": 7657,
	"./whyus/team/nandini2.jpg": 11710,
	"./whyus/team/natasha.jpg": 99659,
	"./whyus/team/natasha1.jpg": 11958,
	"./whyus/team/natasha2.jpg": 61569,
	"./whyus/team/nicole.jpg": 5075,
	"./whyus/team/nicole1.png": 4970,
	"./whyus/team/nicole2.jpg": 55865,
	"./whyus/team/nicole2.png": 53953,
	"./whyus/team/padmini.jpg": 26037,
	"./whyus/team/padmini2.jpg": 5675,
	"./whyus/team/pamela1.png": 84564,
	"./whyus/team/pamela2.png": 19823,
	"./whyus/team/paras1.jpg": 34405,
	"./whyus/team/paras2.jpg": 77178,
	"./whyus/team/philip.jpg": 40943,
	"./whyus/team/philip2.jpg": 40013,
	"./whyus/team/raimond.jpg": 27841,
	"./whyus/team/raimond2.jpg": 75759,
	"./whyus/team/rongyi.jpg": 4249,
	"./whyus/team/rongyi2.jpg": 57591,
	"./whyus/team/rui.jpg": 12939,
	"./whyus/team/rui2.jpg": 21921,
	"./whyus/team/ryan1.png": 81884,
	"./whyus/team/ryan2.png": 5815,
	"./whyus/team/shalini.jpg": 15451,
	"./whyus/team/shalini2.jpg": 18833,
	"./whyus/team/shan.jpg": 35339,
	"./whyus/team/shan2.png": 20809,
	"./whyus/team/shanhui1.jpg": 28348,
	"./whyus/team/shanhui2.png": 56211,
	"./whyus/team/shawn1.png": 56797,
	"./whyus/team/shawn2.png": 75590,
	"./whyus/team/siu.jpg": 10290,
	"./whyus/team/siu2.png": 43798,
	"./whyus/team/solomon1.png": 56037,
	"./whyus/team/solomon2.png": 37262,
	"./whyus/team/sunchang.jpg": 71302,
	"./whyus/team/sunchang1.jpg": 26393,
	"./whyus/team/sunchang2.jpg": 11374,
	"./whyus/team/terence.jpg": 53331,
	"./whyus/team/terence2.jpg": 46969,
	"./whyus/team/tessa.jpg": 85427,
	"./whyus/team/tessa1.jpg": 56654,
	"./whyus/team/tessa2.jpg": 71673,
	"./whyus/team/trevor.jpg": 89811,
	"./whyus/team/trevor1.jpg": 31598,
	"./whyus/team/trevor2.jpg": 11865,
	"./whyus/team/wenjun.jpg": 74294,
	"./whyus/team/wenjun2.jpg": 77438,
	"./whyus/team/yongyang.jpg": 58941,
	"./whyus/team/yongyang1.jpg": 1428,
	"./whyus/team/yongyang2.jpg": 47491,
	"./whyus/team/youjoh1.jpg": 3698,
	"./whyus/team/youjoh2.jpg": 13597,
	"./whyus/team/zhijian.jpg": 54754,
	"./whyus/team/zhijian2.jpg": 59746
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73811;